import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";

const services = [
  {
    icon: "ri-car-line",
    title: "Grúa para turismos",
    desc: "Recogida y traslado de vehículos particulares en las provincias de Lleida y Huesca. Servicio rápido, seguro y con cobertura de seguros. Atendemos averías, accidentes y traslados programados.",
    image: "https://public.readdy.ai/ai/img_res/6ab12aa9aa7a3fcb030f35916363f25a.jpg",
  },
  {
    icon: "ri-truck-line",
    title: "Grúa para vehículos pesados",
    desc: "Equipos especializados para la recuperación y traslado de camiones, autobuses, maquinaria pesada y vehículos de gran tonelaje. Disponemos de grúas de alta capacidad para cualquier situación.",
    image: "https://readdy.ai/api/search-image?query=heavy%20duty%20recovery%20truck%20towing%20a%20large%20semi%20truck%20on%20highway%20Spain%2C%20professional%20heavy%20vehicle%20recovery%20service&width=700&height=450&seq=srv2&orientation=landscape",
  },
  {
    icon: "ri-settings-3-line",
    title: "Transporte de maquinaria",
    desc: "Traslado especializado de maquinaria agrícola, industrial y de construcción. Contamos con plataformas y equipos adecuados para cada tipo de carga, con todos los permisos de transporte especial.",
    image: "https://readdy.ai/api/search-image?query=flatbed%20truck%20transporting%20large%20agricultural%20tractor%20in%20Aragon%20Spain%20countryside%2C%20professional%20logistics%2C%20daytime&width=700&height=450&seq=srv3&orientation=landscape",
  },
  {
    icon: "ri-tools-line",
    title: "Asistencia en carretera",
    desc: "Avería, pinchazo, batería descargada, falta de combustible o accidente. Nuestro equipo llega donde nos necesitas en el menor tiempo posible en las provincias de Lleida y Huesca.",
    image: "https://readdy.ai/api/search-image?query=roadside%20assistance%20mechanic%20helping%20driver%20with%20broken%20car%20on%20Spanish%20highway%2C%20professional%20service%2C%20safety%20vest%2C%20daytime&width=700&height=450&seq=srv4&orientation=landscape",
  },
  {
    icon: "ri-exchange-line",
    title: "Traslado de vehículos",
    desc: "Servicio de traslado de vehículos entre concesionarios, talleres, puertos y particulares. Transporte seguro con plataformas cerradas o abiertas según las necesidades del cliente.",
    image: "https://readdy.ai/api/search-image?query=car%20transport%20truck%20carrying%20multiple%20vehicles%20on%20Spanish%20motorway%2C%20professional%20vehicle%20transport%20logistics%2C%20daytime&width=700&height=450&seq=srv5&orientation=landscape",
  },
  {
    icon: "ri-shield-check-line",
    title: "Gestión con aseguradoras",
    desc: "Trabajamos con todas las compañías aseguradoras. Nos encargamos de toda la gestión y papeleo para que el cliente no tenga que preocuparse de nada en momentos difíciles.",
    image: "https://readdy.ai/api/search-image?query=insurance%20agent%20and%20tow%20truck%20driver%20discussing%20paperwork%20at%20accident%20scene%2C%20professional%20service%2C%20Spain%2C%20daytime&width=700&height=450&seq=srv6&orientation=landscape",
  },
];

export default function ServiciosPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="relative h-72 md:h-96 flex items-center justify-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=fleet%20of%20tow%20trucks%20parked%20at%20logistics%20depot%20in%20Spain%2C%20professional%20transport%20company%2C%20industrial%20photography%2C%20wide%20angle&width=1920&height=600&seq=shero&orientation=landscape"
          alt="Servicios GERPAT"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative z-10 text-center px-4">
          <span className="text-[#FF6B35] text-xs font-bold uppercase tracking-widest">GERPAT Logística</span>
          <h1 className="text-4xl md:text-5xl font-extrabold text-white mt-2" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
            NUESTROS SERVICIOS
          </h1>
          <p className="text-gray-300 mt-3 text-base max-w-xl mx-auto">
            Soluciones profesionales de grúa, transporte y asistencia en carretera en Lleida y Huesca
          </p>
        </div>
      </section>

      {/* Services grid */}
      <section className="py-20 bg-[#f8f7f5]">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((s) => (
              <div key={s.title} className="bg-white rounded-xl overflow-hidden group hover:-translate-y-1 transition-transform duration-300">
                <div className="w-full h-52 overflow-hidden">
                  <img src={s.image} alt={s.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35]/10 rounded-lg mb-3">
                    <i className={`${s.icon} text-[#FF6B35] text-xl`}></i>
                  </div>
                  <h3 className="font-bold text-[#1a1a1a] text-lg mb-2">{s.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#1a1a1a] py-16 text-center">
        <div className="max-w-2xl mx-auto px-4">
          <h2 className="text-3xl font-extrabold text-white mb-4" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>¿NECESITA UN SERVICIO?</h2>
          <p className="text-gray-400 mb-8">Contacte con nosotros ahora mismo. Cubrimos Lleida y Huesca.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:+34638250936" className="flex items-center justify-center gap-2 bg-[#FF6B35] hover:bg-[#e55a25] text-white font-bold px-8 py-3.5 rounded-full transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-phone-fill"></i> Llamar ahora
            </a>
            <Link to="/contacto" className="flex items-center justify-center gap-2 border border-white/30 hover:border-[#FF6B35] text-white font-bold px-8 py-3.5 rounded-full transition-colors whitespace-nowrap cursor-pointer">
              Formulario de contacto
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
